import { useParams, useNavigate } from "react-router-dom";
import { useApi } from "./useApi";

interface UseDetailPageResult<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
    navigate: ReturnType<typeof useNavigate>;
    id: string | undefined;
    refetch: () => Promise<void>;
}

export function useDetails<T>(basePath: string): UseDetailPageResult<T> {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    // refreshTrigger > 0: always fetch fresh on open (avoid stale 2-min cache after portal submit)
    const { data, loading, error, refetch } = useApi<T>(
        id ? `/${basePath}/${id}` : "",
        id ? 1 : 0,
    );

    return { data, loading, error, navigate, id, refetch };
}
